import { useState, useEffect } from 'react';
import { getCookie, setCookie } from '@Components/Utilities/CookieHelper';
import { cookieNames } from '@Components/Utilities/SandhillsConstants';
import TranslationText from '@Components/Utilities/TranslationText';
import ready from 'document-ready';

const CookieBanner = (props) => {

    const [showBanner, setShowBanner] = useState(true);
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        ready(() => {
            if (getCookie(cookieNames.cookieBanner)) {
                setShowBanner(false);
            } else {
                setFadeIn(true);
            }
        });
    }, []);

    const onClick = () => {
        setFadeIn(false);
        setTimeout(() => setShowBanner(false), 1000);
        let date = new Date;
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * 365);
        let expiresOn = date.toUTCString();
        setCookie(cookieNames.cookieBanner, 'CookieConsent', expiresOn);
    };

    return showBanner ? (
        <div className={'cookie-banner' + (fadeIn ? ' cookie-banner_fade-in' : '')}>
            <div className='cookie-banner__content'>
                <TranslationText tKey='sandhills.tradepubwebsite.mvc.cookieconsentmessage' />
            </div>
            <div className='cookie-banner__content'>
                <a href={props.CookiesPolicyLink} className='cookie-banner__btn-unfilled'><TranslationText tKey='sandhills.tradepubwebsite.mvc.learnmore' /></a>
                <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); onClick(); } }} className='cookie-banner__btn-filled' onClick={onClick}><TranslationText tKey='sandhills.tradepubwebsite.mvc.gotit!' /></a>
            </div>
        </div>
    ) : (
        <></>
    );
};

export default CookieBanner;
global.CookieBanner = CookieBanner;